export function PartnerCard({ logo, logoAlt, name, badge, desc, scopeTitle, scopes, location, website, websiteLabel, context, contactPerson, phone, email, address }) {
    return (
        <div className="partner-card">
            <div className="partner-card-header">
                <img src={logo} alt={logoAlt} className="partner-logo" />
                {badge && <div className="partner-card-badge">{badge}</div>}
            </div>

            <div className="partner-card-body">
                <h2 className="partner-company-name">{name}</h2>
                {desc && <p className="partner-desc">{desc}</p>}

                {scopes && scopes.length > 0 && (
                    <div className="partner-scope">
                        <h3 className="partner-scope-title">{scopeTitle}</h3>
                        <ul className="partner-scope-list">
                            {scopes.map((s) => <li key={s}>{s}</li>)}
                        </ul>
                    </div>
                )}

                <div className="partner-contact-line">
                    {location && (
                        <div className="partner-info">
                            <img src="/img/icones/i-gps.png" alt="" aria-hidden="true" className="partner-icon" />
                            <span>{location}</span>
                        </div>
                    )}
                    {website && (
                        <div className="partner-info">
                            <img src="/img/icones/i-build.png" alt="" aria-hidden="true" className="partner-icon" />
                            <a href={website} target="_blank" rel="noopener noreferrer" className="partner-link">
                                {websiteLabel || website}
                            </a>
                        </div>
                    )}
                </div>

                {(contactPerson || phone || email || address) && (
                    <div className="partner-contact-card">
                        {contactPerson && <p className="partner-contact-person"><strong>{contactPerson}</strong></p>}
                        {phone && (
                            <div className="partner-info">
                                <img src="/img/icones/i-phone.png" alt="" aria-hidden="true" className="partner-icon" />
                                <a href={`tel:${phone}`}>{phone}</a>
                            </div>
                        )}
                        {email && (
                            <div className="partner-info">
                                <img src="/img/icones/i-mail.png" alt="" aria-hidden="true" className="partner-icon" />
                                <a href={`mailto:${email}`} className="partner-link">{email}</a>
                            </div>
                        )}
                        {address && (
                            <div className="partner-info">
                                <img src="/img/icones/i-gps.png" alt="" aria-hidden="true" className="partner-icon" />
                                <p className="partner-address">{address}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {context && (
                <div className="partner-context">
                    <p>{context}</p>
                </div>
            )}
        </div>
    );
}